import user from '../utils/questionConfig'
import isMobile from '../utils/isMobile'
import store from '../store/index'
export default function () {							/*判斷機型*/
    var osUserAgent = navigator.userAgent.match(/\([^\)]+\)/)[0].toLowerCase();
    user.date(window);
    var osUserAgent = navigator.userAgent.toLowerCase();
    if (location.href.indexOf('wx=') != -1 || location.href.indexOf('login=') != -1 || location.href.indexOf('weixcode=') != -1) {
        return "other";
    } else {
        if (osUserAgent.indexOf("ipad") > -1 || osUserAgent.indexOf("ipod") > -1) {
            return "ipad";
        } else if (osUserAgent.indexOf("awesomium") > -1) {
            return "u3d";
        } else if (osUserAgent.indexOf("untiypcsdk") > -1) {
            return "u3dPc";
        } else if (!isMobile()) {
            return "ipad";  //PC web
        } else {
            return "other";
        }
    }
}